import ApiService from '@/common/ApiService/ApiService';
import { HttpVerb } from '@/common/ApiService/HttpVerb';
import { apiData } from '@/modules/UnsubscribeModule/UnsubscribeModule.types';

const serviceOptions = {
  cancel: true,
  returnData: true,
  showLoading: true,
};

const UnsubscribeEmailService = new ApiService('/api/EmailSignUpService/', serviceOptions);

export const UnsubscribeEmail = async (data: apiData): Promise<any> =>
  await UnsubscribeEmailService.call('EmailUnsubscribe', data, {
    verb: HttpVerb.POST,
  });

const UnsubscribeDerEmailService = new ApiService('/api/DerService/', serviceOptions);

export const UnsubscribeDerEmail = async (data: apiData): Promise<any> =>
  await UnsubscribeDerEmailService.call('CheckEmailAndUnsubscribe', data, {
    verb: HttpVerb.POST,
  });

export const getAllEmailsList = async (data: apiData): Promise<any> =>
  await UnsubscribeDerEmailService.call('GetSignUpList', data, {
    verb: HttpVerb.POST,
  });
